import Fernet from 'fernet-web';

const fernetPromise = Fernet.create(import.meta.env.VITE_FERNET_SECRET_KEY);

export const encryptedData = async (data: unknown) => {
  const fernet = await fernetPromise;
  const encrypted = await fernet.encrypt(JSON.stringify(data));
  return { encrypted };
};
